import { ColorOptions } from "../types/colorOptions";
import { mapToBackgroundClass } from "./backgroundColorMapping";
import { mapToTextClass } from "./textColorMapping";

export const mapToLinkButtonClasses = (options?: ColorOptions) => {
    return `${mapToTextClass(options?.fontColor)} ${mapToBackgroundClass(
        options?.backgroundColor
    )}`;
};
